const TOTAL_PAGES = 3;

const CHARACTER_LINES = [
	"ABCDEFGHIJKLMNOPQRSTUVWXYZ",
	"abcdefghijklmnopqrstuvwxyz",
	"0123456789 .,;:!?()[]%&@+-/ CHF «»",
	"Ää Öö Üü é à è ç",
];

const PANGRAM =
	"Zwölf Boxkämpfer jagen Viktor quer über den grossen Sylter Deich.";

const SAMPLE_ROWS = [
	{ code: "2012.1", qty: 1, text: "Modell aus Hartgips", amount: "32.80" },
	{ code: "2017.1", qty: 1, text: "Sägeschnittmodell", amount: "64.30" },
	{
		code: "2026.1",
		qty: 8,
		text: "Platzhalter für Konfektionsteil in Abdruck einsetzen",
		amount: "111.20",
	},
	{
		code: "2032.1",
		qty: 2,
		text: "Modelle in Mittelwertartikulator oder in einfachen individuellen Artikulator einsetzen",
		amount: "47.30",
	},
	{
		code: "3038.1",
		qty: 1,
		text: "Gegenmodell einartikulieren",
		amount: "27.70",
	},
	{
		code: "4104.1",
		qty: 4,
		text: "Wurzelkappe modellieren",
		amount: "377.90",
	},
];

const TestPage: React.FC<{ pageNumber: number }> = ({ pageNumber }) => {
	return (
		<div
			className={pageNumber > 1 ? "pdf-page-break" : undefined}
			style={{ padding: "10mm" }}
		>
			<div className="flex items-baseline justify-between border-b-2 border-gray-800 pb-2 mb-4">
				<span style={{ fontSize: "16pt", fontWeight: 700 }}>
					dentLAB Drucktest
				</span>
				<span style={{ fontSize: "12pt" }}>
					Seite {pageNumber} von {TOTAL_PAGES}
				</span>
			</div>

			{pageNumber === 1 && (
				<p style={{ fontSize: "10pt" }} className="mb-4">
					Dieses Dokument prüft, ob Ihr Drucker mehrseitige Dokumente
					aus dentLAB korrekt druckt. Bei fehlerhaften Druckertreibern
					ist die erste Seite korrekt, ab der zweiten Seite erscheinen
					unlesbare Zeichen. Vergleichen Sie deshalb alle drei Seiten:
					Jede Seite muss identisch aufgebaut und vollständig lesbar
					sein.
				</p>
			)}

			<div className="mb-4">
				<div
					style={{ fontSize: "11pt", fontWeight: 700 }}
					className="mb-1"
				>
					Zeichensatz
				</div>
				{CHARACTER_LINES.map((line) => (
					<div key={line} style={{ fontSize: "11pt" }}>
						{line}
					</div>
				))}
			</div>

			<div className="mb-4">
				<div
					style={{ fontSize: "11pt", fontWeight: 700 }}
					className="mb-1"
				>
					Schriftgrössen
				</div>
				{[8, 10, 12, 16].map((size) => (
					<div key={size} style={{ fontSize: `${size}pt` }}>
						{size}pt — {PANGRAM}
					</div>
				))}
				<div style={{ fontSize: "11pt", fontWeight: 700 }}>
					Fett — {PANGRAM}
				</div>
			</div>

			<div className="mb-4">
				<div
					style={{ fontSize: "11pt", fontWeight: 700 }}
					className="mb-1"
				>
					Beispielpositionen
				</div>
				<table className="w-full" style={{ fontSize: "9pt" }}>
					<thead>
						<tr className="border-b border-gray-400 text-left">
							<th className="pr-2 py-0.5">Code</th>
							<th className="pr-2 py-0.5">Menge</th>
							<th className="pr-2 py-0.5">Text</th>
							<th className="py-0.5 text-right">Betrag</th>
						</tr>
					</thead>
					<tbody>
						{SAMPLE_ROWS.map((row) => (
							<tr
								key={row.code}
								className="border-b border-gray-200"
							>
								<td className="pr-2 py-0.5">{row.code}</td>
								<td className="pr-2 py-0.5">{row.qty}</td>
								<td className="pr-2 py-0.5">{row.text}</td>
								<td className="py-0.5 text-right">
									{row.amount}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div
				className="border-2 border-gray-800 p-3"
				style={{ fontSize: "10pt" }}
			>
				<div style={{ fontWeight: 700 }} className="mb-1">
					Prüfpunkt Seite {pageNumber}
				</div>
				<p>
					Ist jede Zeile auf dieser Seite einwandfrei lesbar?
					Erscheinen auf Seite 2 oder 3 wirre Zeichen
					("Hieroglyphen"), aktivieren Sie in dentLAB unter
					Organisation → Drucker den Treiber-Kompatibilitätsmodus für
					diesen Drucker und wiederholen Sie den Drucktest.
				</p>
			</div>
		</div>
	);
};

export const DruckertestTemplate: React.FC = () => {
	return (
		<div
			style={{
				fontFamily: "LiberationSans",
				fontWeight: 400,
				fontStyle: "normal",
				width: "210mm",
			}}
		>
			{Array.from({ length: TOTAL_PAGES }, (_, i) => (
				<TestPage key={i + 1} pageNumber={i + 1} />
			))}
		</div>
	);
};
